import React from "react";
import { TForm, TInputElementProps, TInputProps } from "@/components/form/types";
import useForm from "./index";
import Label from "./label";

export const TextInput = ({ container, label, input, tooltip, className, hidden, options }: TInputElementProps<TTextInput>) => {
    if (hidden) {
        return null;
    }

    return (
        <div {...container} className={container?.className ?? className}>
            <Label {...label} tooltip={tooltip} options={options}/>
            {/*// @ts-ignore*/}
            <textarea {...input}/>
        </div>
    );
}

type TTextInput = string;
const useTextInput = <T extends TTextInput>(props: TInputProps<T>): TForm<TTextInput> => {
    const form = useForm<TTextInput>({
        id: "text",
        default: "",
        ...props,
    })

    return {
        ...form,
    }
};

export default useTextInput;
